import React from "react";
import IconMenu from "material-ui/IconMenu";
import MenuItem from "material-ui/MenuItem";
import IconButton from "material-ui/IconButton";
import MoreHorizIcon from "material-ui/svg-icons/navigation/more-horiz";
import EditButton from "./EditButton";
import DeleteButton from "./DeleteButton";
import ShowButton from "./ShowButton";

const ActionMenu = ({
  resource,
  basePath,
  editButton,
  deleteButton,
  showButton,
  record
}) => {
  return (
    <IconMenu
      iconButtonElement={
        <IconButton>
          <MoreHorizIcon />
        </IconButton>
      }
      anchorOrigin={{horizontal: "left", vertical: "top"}}
      targetOrigin={{horizontal: "left", vertical: "top"}}
      useLayerForClickAway={true}
    >
      {editButton !== false && (
        <MenuItem
          children={<EditButton basePath={basePath} record={record} />}
        />
      )}

      {showButton === true && (
        <MenuItem
          children={<ShowButton basePath={basePath} record={record} />}
        />
      )}

      {deleteButton !== false && (
        <MenuItem
          children={<DeleteButton basePath={basePath} record={record} />}
        />
      )}
    </IconMenu>
  );
};

export default ActionMenu;



// WEBPACK FOOTER //
// ./src/components/CRM/ActionMenu.js